import { useCallback } from 'react';

export const usePreselectableDrawer = <T extends string>(
  isValidFormat: (type: string) => boolean,
  onDrawerOpen: () => void,
  setSelection: (type: T) => void
) => {
  return useCallback(
    (type?: string) => {
      onDrawerOpen();

      if (type && isValidFormat(type)) {
        setSelection(type as T);
      }
    },
    [onDrawerOpen, setSelection, isValidFormat]
  );
};
